import React from 'react'

import { CourseSection } from '../../../../api/courses/types'
import Collapsable from '../../layout/Collapsable'
import Card from '../../layout/Card'
import CourseVideoCard from './VideoCard'
import { useI18N } from '../../../../libraries/i18n/hook'
import MetadataLabel from '../MetadataLabel'

type Props = { courseId: number | string, sections?: CourseSection[] }
const VideoSections: React.FC<Props> = ({ sections, courseId }) => {
  const { t } = useI18N()

  const renderSection = (section: CourseSection) => {
    if(!section.videos || section.videos.length === 0) { return null }

    const isSectionWatched = section.videos.every((video) => video.userActivity?.watched)
    const sectionLabel = isSectionWatched
      ? (
        <div className='flex flex-wrap w-full justify-between items-center gap-y-2 pe-2 sm:pe-6 sm:pb-0'>
          <b>{section.title}</b>
          <div className='text-2xs sm:text-xs font-normal text-deep-green sm:pb-0'>
            <MetadataLabel strokeColor='deep-green' icon='checked'>{t('courses.completed.section')}</MetadataLabel>
          </div>
        </div>
      )
      : <b>{section.title}</b>
    return (
      <Collapsable size='lg' key={section.title} label={sectionLabel}>
        {renderVideos(section)}
      </Collapsable>
    )
  }

  const renderVideos = (section: CourseSection) => {
    return (
      section.videos?.map((video) => (
        <div key={video.id} className='w-full'>
          <CourseVideoCard courseId={courseId} video={video} />
        </div>
      ))
    )
  }

  if(!sections || sections.length === 0) return null
  const filteredSections = filterSectionsWithNoVideos(sections)
  return (
    <>
      {filteredSections.length === 1
        ? <div><Card className='bg-white w-full'>{renderVideos(filteredSections[0])}</Card></div>
        : filteredSections?.map(renderSection)
      }
    </>
  )
}

const filterSectionsWithNoVideos = (sections: CourseSection[]): CourseSection[] => {
  return sections.filter((section) => section.videos && section.videos.length > 0)
}

export default VideoSections
